import React from "react";
import { translate } from "@helpers/translationObjectFormatter";
import { TranslationsObject } from "@genericTypes/sharedTypes";
import { useQuery } from "@tanstack/react-query";
import styles from "./style.module.scss";
import OurTeamLogo from "./logo";
const OurTeam = () => {
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    return (
        <section className=" flex flex-col lg:flex-row gap-9 mt-28 w-fit mx-auto ">
            <div className=" w-fit mx-auto">
                <OurTeamLogo />
            </div>
            <div>
                <h2 className={styles["text"]}>
                    {translate(
                        translations,
                        "several_aboutUsPage_OurTeamComprisesDescription",
                    )}
                </h2>
                <p className=" font-medium lg:text-lg text-base lg:leading-9 leading-7 max-w-2xl relative mt-5 lg:text-left text-center mx-5 lg:mx-0">
                    {translate(
                        translations,
                        "several_aboutUsPage_OurTeamComprisesTitle",
                    )}
                </p>
            </div>
        </section>
    );
};

export default OurTeam;
